import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

// Visible breadcrumb that matches the BreadcrumbList JSON-LD. items: [{name, path}]
export const Breadcrumbs = ({ items }) => (
  <nav data-testid="breadcrumbs" aria-label="Breadcrumb" className="text-sm text-brand-inkSoft">
    <ol className="flex flex-wrap items-center gap-1.5">
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <li key={it.path} className="flex items-center gap-1.5">
            {i > 0 && <ChevronRight size={13} className="opacity-60" />}
            {last ? (
              <span className="text-brand-ink" aria-current="page">{it.name}</span>
            ) : (
              <Link to={it.path} className="link-underline hover:text-brand-ink">{it.name}</Link>
            )}
          </li>
        );
      })}
    </ol>
  </nav>
);

export default Breadcrumbs;
